import { TabContainer } from "../components/Tab/TabContainer";
import { FCC } from "../utils/reactHelpers/types";

export const Settings: FCC = ({ children }) => {
  return <TabContainer>This is settings tab</TabContainer>;
};
